import React from "react";
import { Button } from "@/components/Button";
import { ProductCard } from "@/features/product/ProductCard";
import {
  useCancelItem,
  useSelectedItemContext,
} from "../../SelectedItemContext";
import { DrawerPageProps } from "../types";
import {
  droppsProductToProductCardProduct,
  getDisplayDate,
} from "../../helpers";
import { productSelect } from "@/store";

export interface CancelSubscriptionPageProps extends DrawerPageProps {}

const CancelSubscriptionPage = ({
  notify,
  onExit,
  onBack,
}: CancelSubscriptionPageProps) => {
  const { rechargeItem, variant, product } = useSelectedItemContext().boxItem;
  const upcomingOrderCanceler = useCancelItem();
  const dateString = getDisplayDate(rechargeItem.nextChargeDate);

  const isSubscription = rechargeItem.status !== "ONETIME";
  const cancelSelectedSubscription = () => {
    upcomingOrderCanceler.mutate(undefined, {
      onSuccess: () => {
        notify({
          title: isSubscription
            ? "Subscription Cancellation"
            : "Product Deletion",
          message: isSubscription
            ? "Your subscription has been cancelled."
            : "Your product has been deleted.",
        });
        onExit();
      },
      onError: () => {
        notify({
          title: isSubscription
            ? "Subscription Cancellation"
            : "Product Deletion",
          message: isSubscription
            ? "There was an error cancelling your subscription."
            : "There was an error deleting your product.",
          severity: "error",
        });
      },
    });
  };

  return (
    <>
      <div className="w-full space-y-4">
        <label className="subtitle text-base font-semibold">
          {isSubscription ? "Cancel Subscription" : "Remove Item"}
        </label>
        <ProductCard
          productCardValue={droppsProductToProductCardProduct({
            product,
            variant,
          })}
          compact={true}
          hoverable={false}
          bordered
          productTitle={
            <h3 data-id="product-card-title" className="title text-sm">
              {productSelect.name(product)}
            </h3>
          }
        />
      </div>
      <div className="w-full space-y-4">
        <p className="body text-sm">
          This {isSubscription ? "subscription" : "product"} was scheduled to
          ship on:
        </p>
        <ul className="ml-5 text-sm">
          <li className="list-disc">{dateString}</li>
        </ul>
        <Button className="w-full" onClick={cancelSelectedSubscription}>
          {isSubscription ? "Confirm Cancellation" : "Remove Item"}
        </Button>
        <Button onClick={onBack} className="btn-ghost w-full">
          Go Back
        </Button>
      </div>
    </>
  );
};

export { CancelSubscriptionPage };
